import React, { useCallback, useEffect } from "react";
import { selectors as stationSelectors, actions as stationActions } from "@containers/Station/store";
import { useDispatch, useSelector } from "react-redux";
import { actions as sharedActions } from "@shared/store";
import { StationIssue } from "@shared/models";
import { StationIssuesList } from "@containers/Station/components/StationIssuesListContainer";
import { MODAL_TYPES } from "@shared/constants";

interface StationIssuesListContainerProps {
  hospitalId: number;
  onRowClick: (item: StationIssue) => void;
  onClose: () => void;
}

const StationIssuesListContainer = (props: StationIssuesListContainerProps) => {
  const dispatch = useDispatch();
  const { onClose, hospitalId, onRowClick } = props;

  const stationsIssuesFilter = useSelector(stationSelectors.getStationsIssuesFilter());
  const stationsIssues = useSelector(stationSelectors.selectStationsIssues());
  const stationsIssuesTotal = useSelector(stationSelectors.selectTotaStationsIssuesCount());

  const handleReadStationIssue = useCallback(
    (issue: StationIssue) => {
      dispatch(
        sharedActions.showModal({
          type: MODAL_TYPES.ISSUE_READ_CONFIRM,
          props: {
            issue,
            onSuccess: (comment: string) => {
              dispatch(
                stationActions.readStationIssue.request({
                  id: issue.id,
                  comment,
                }),
              );
            },
          },
        }),
      );
    },
    [dispatch],
  );

  const loadNextPage = useCallback(() => {
    if (stationsIssuesFilter.limit * (stationsIssuesFilter.page + 1) < stationsIssuesTotal) {
      dispatch(
        stationActions.setStationsIssuesFilter({
          ...stationsIssuesFilter,
          page: stationsIssuesFilter.page + 1,
        }),
      );
    }
  }, [dispatch, stationsIssuesFilter, stationsIssuesTotal]);

  useEffect(() => {
    dispatch(
      stationActions.loadStationsIssues.request({
        ...stationsIssuesFilter,
        hospital_id: hospitalId,
      }),
    );
  }, [dispatch, hospitalId, stationsIssuesFilter]);

  return (
    <div className="alert-notifications-list-container">
      <StationIssuesList
        issues={stationsIssues}
        loadNextPage={loadNextPage}
        title="SDH Issues"
        onClose={onClose}
        onRowClick={onRowClick}
        onClickMarkAsRead={handleReadStationIssue}
      />
    </div>
  );
};

export default StationIssuesListContainer;
